import { FunctionComponent, PropsWithChildren } from "react";
import styles from "./Typography.module.css";

type TProps = {
  variant: "body" | "body-small" | "code";
};

const Typography: FunctionComponent<PropsWithChildren<TProps>> = (props) => {
  switch (props.variant) {
    case "body":
      return <span className={styles.body}>{props.children}</span>;

    case "body-small":
      return <span className={styles.bodySmall}>{props.children}</span>;

    case "code":
      return <code className={styles.code}>{props.children}</code>;

    default:
      return <span>{props.children}</span>;
  }
};

export default Typography;
